const BigIconSkeleton = () => {
  return (
    <div className="p-12 sm:p-16 sm:w-1/2 md:w-1/3 flex flex-row sm:flex-col items-center">
      <div className="rounded-full bg-white icon-76 sm:icon-128 mr-12 sm:mr-0 sm:mb-12 flex-shrink-0" />
      <div className="rounded-md bg-white w-3/5 sm:w-4/5 sm:mx-auto h-28 sm:h-32" />
    </div>
  );
};
const SkeletonLoader = () => {
  return (
    <div className="bg-blue-dark py-36 px-24 flex flex-1 flex-col">
      <div className="animate-pulse opacity-75 sm:container-2xl">
        <div className="px-12 sm:px-16 mb-24 sm:mb-36">
          <div className="bg-white opacity-20 mb-48 md:mb-64 rounded-md w-full h-80" />
          <div className="bg-white opacity-20 rounded-md w-full h-32 sm:h-48 mb-8 sm:w-11/12 sm:mx-auto" />
          <div className="sm:hidden bg-white opacity-20 rounded-md w-2/5 h-32" />
        </div>
        <div className="sm:flex sm:justify-center sm:flex-wrap opacity-20 mt-2">
          {Array.from(Array(6), (_, i) => (
            <BigIconSkeleton key={`bigiconskel${i}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
